/* globals Store */
import api from './backend-api'
import router from '../router'
/* eslint-disable */


export default {
    login(data, cb) {
        cb = arguments[arguments.length - 1]
        let Data={
            platform:'web',
            device_token:localStorage.getItem('device_token')
        }
        api.postData('auth/login', data)
        .then((res) => {

            let status=res.data.responce.club_status

            if(status=='inactive'){
              let packageid=res.data.responce.package_details.id
              router.push('/complete/'+packageid);
              // }else if(status=="active"){
              }else if( new String(status).valueOf()==new String("active").valueOf()){
                Store.dispatch('Login');
                api.postData('auth/saveDevice',Data)
                .then(res=>{
                    console.log("Device token sent to server")
                })
                // if (cb) cb(true, null)
                // this.onChange(true)
                // setTimeout(() => {
                //   // window.location.href = '/';
                // }, 800);

            }else if(res.data.responce.club_status=="club_not_created_yet"){
              router.push('/complete');
            }
            const token = res.data.token
            const userinfo = res.data.user
            const adminPackageInfo=res.data.responce
            const user={...userinfo,...adminPackageInfo}

            var expireDate=new Date()
            expireDate.setMinutes(expireDate.getMinutes()+res.data.expires_in_minutes)
            expireDate=new Date(expireDate)
            const pusherToken=res.data.unique_token
            Store.dispatch('updateUser', { user, token ,pusherToken,expireDate})
            Store.state.SidebarStatus=true;
        }
        , (err) => {

            if (cb) cb(false, err)
            this.onChange(false)
        }).catch((error)=>{
          console.log(error)
        })
    },
    getToken() {
        return Store.state.token
    },
    logout(cb) {
        // delete localStorage.token
        // Store.commit('setToken', null)
        Store.state.SidebarStatus=false;
        Store.dispatch('logout')
        setTimeout(()=>{
          localStorage.setItem("vuex", "")
          localStorage.removeItem("vuex")
          if (cb) cb(false)
          // this.onChange(false)
        },1000);
    },
    loggedIn() {
      return Store.state.token
    },
    onChange() {}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js